import { Component, OnInit, Inject } from "@angular/core";

import personDataservice = require("../core/persons.dataservice");
import workGroupDataservice = require("../core/workgroups.dataservice");
import workplaceDataservice = require("../core/workplaces.dataservice");
import activityTypeDataservice = require("../core/activitytypes.dataservice");
import jobTitleDataservice = require("../core/jobtitles.dataservice");
import search = require("../core/search.dataservice");
import dataCore = require("../core/datacore");

@Component({
    selector: "crew-search-activities",
    template: require('./search-activities.component.html')
})
export class SearchActivitiesComponent implements OnInit {

    constructor(
        @Inject(personDataservice.PersonDataService.Id) private personDataService: personDataservice.PersonDataService,
        @Inject(workGroupDataservice.WorkGroupsDataService.Id) private workGroupDataservice: workGroupDataservice.WorkGroupsDataService,
        @Inject(workplaceDataservice.WorkplaceDataService.Id) private workplaceDataService: workplaceDataservice.WorkplaceDataService,
        @Inject(activityTypeDataservice.ActivityTypeDataService.Id) private activityTypeDataService: activityTypeDataservice.ActivityTypeDataService,
        @Inject(jobTitleDataservice.JobTitlesDataService.Id) private jobTitleDataservice: jobTitleDataservice.JobTitlesDataService,
        @Inject(search.SearchService.Id) private searchService: search.SearchService,
        @Inject("$q") private $q: ng.IQService,
        @Inject("$log") private $log: ng.ILogService) { }

    public fromDate: Date = this.addToDateNow(-30);

    public toDate: Date = dataCore.getToday();

    public persons: Nema.Crew.Model.Person[] = [];
    public workGroups: Nema.Crew.Model.WorkGroup[] = [];
    public selectedPersons: Nema.Crew.Model.Person[] = [];

    public workplaces: Nema.Crew.Model.Workplace[] = [];
    public selectedWorkplaces: Nema.Crew.Model.Workplace[] = [];

    public activityTypes: Nema.Crew.Model.ActivityType[] = [];
    public selectedActivityTypes: Nema.Crew.Model.ActivityType[] = [];

    public jobTitles: Nema.Crew.Model.JobType[] = [];
    public selectedJobTitles: Nema.Crew.Model.JobType[] = [];

    public resultingActivities: Nema.Crew.Model.ActivitySearchResult[] = [];

    public isLoading: boolean = false;

    ngOnInit() {
        this.isLoading = true;

        this.$q
            .all([
                this.personDataService.getAll(),
                this.workGroupDataservice.getAll(),
                this.workplaceDataService.getAll(),
                this.activityTypeDataService.getAll(),
                this.jobTitleDataservice.getAll()
            ])
            .then(res => {
                this.persons = res[0].filter(p => p.Active);
                this.workGroups = res[1].filter(wg => wg.Active);
                this.workplaces = res[2].filter(w => w.Active);
                this.activityTypes = res[3].filter(at => at.Active);
                this.jobTitles = res[4].filter(jt => jt.Active);
                this.isLoading = false;
            })
            .catch(err => {
                this.$log.error(err);
                this.isLoading = false;
            });
    }

    public search() {

        // Clear the result, before performing the search
        this.resultingActivities = [];
        this.isLoading = true;

        // Construct the query
        var searchQuery: search.SearchActivitiesQuery = {
            From: dataCore.subtractTimezoneOffset(this.fromDate),
            To: dataCore.subtractTimezoneOffset(this.toDate),
            PersonIds: this.selectedPersons.map(person => person.Id),
            WorkplaceIds: this.selectedWorkplaces.map(workplace => workplace.Id),
            ActivityTypeIds: this.selectedActivityTypes.map(activityType => activityType.Id),
            JobTitleIds: this.selectedJobTitles.map(jobTitle => jobTitle.Id)
        };

        // Perform the search
        this.searchService
            .searchActivities(searchQuery)
            .then(res => {
                this.resultingActivities = res;
                this.isLoading = false;
            })
            .catch(err => {
                this.$log.error(err);
                this.isLoading = false;
            });
    }
    
    private addToDateNow(numberOfDays: number): Date {
        let res = dataCore.getToday();
        res.setDate(res.getDate() + numberOfDays);
        return res;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/search-activities.component.ts